import React, { useEffect, useState,Fragment, useReducer } from 'react'
import {Badge, Button, Col, Container, Form, FormControl, InputGroup, ListGroup, Row, OverlayTrigger, Tooltip} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import buscarReducer, { initialStateDisabled } from './storeBuscar/buscar-Reducer'
import { INIT, RESET, SET_DISABLED, SET_TIPO_GESTION } from './storeBuscar/types'
import {useFormik} from 'formik'
import { restarMeses } from '../../common/Formatos'
import { Auth, LoadingComponent } from 'recupero-comunes'

import { validationSchemas } from '../../common/validation-Schemas-directo'
import { useLocation, useNavigate } from 'react-router-dom'
import { limpiarCasosBandeja, obtenerCasosBandeja, obtenerTareasAction, obtenerTareasUsuarioAction } from '../../store/actions/encargado-recupero-action'

const hoy = () => {
  const fecha = new Date()
  const hoy = fecha.toISOString().split('T')[0]
  return hoy
}
const resetValues={tipofecha:'',estadocaso:'',
   tarea:'',todos:false,idcaso:'',patente:'',siniestro:'',companias:'',
    fechahasta:'',fechadesde:'', sitDePendiente:''}
    
const BuscarCasos = ({tipoGestion}) => {  
  const history = useNavigate()
  const [loading, setLoading]=useState(false)
  const [myValues, setMyValues]=useState(resetValues)
  const [noFechas, setNoFechas]=useState(true)

  const [selected, setSelected]=useState('')
  const [dias, setDias]=useState('')
  
  const [isDias, setIsDias]=useState(false)
  
  const [isFechas, setIsfechas]=useState(true)
  const {rutUsuario, rutOrganizacion}=Auth.currentUser()

  const [showModal, setShowModal] = useState(false);
  const [mensajeModal, setMensajeModal] = useState("");

  const data_encargado_recupero = useSelector(
    (state) => state.recupero_cias
  )
  const {
    cfg_form,
    rangofechas,
    companias,   
    tareas,
    estadocaso,   
    criteriofecha,
    tareasusuario,
    situacionPendientes
  } = data_encargado_recupero
  
    const [stateBuscar, dispatchBuscar]=useReducer(buscarReducer, initialStateDisabled)
    const dispatch = useDispatch()
    const { state } = useLocation()
    let querState =state?.queryState && state?.queryState
    //RG-536 los filtros eliminados pueden venir en búsquedas guardadas antes del cambio
    //(`localStorage.filtrosRecuperoCias`, que la grilla rehidrata al volver del detalle).
    if (querState) {
      delete querState.respuestacia
      delete querState.motivorpta
    }
    
    const handleRadio=(e)=>{
      setSelected(e.target.id)
      if(e.target.id==='tipogestion'){
       
        dispatchBuscar({type:RESET})
        dispatchBuscar({type:SET_TIPO_GESTION, payload:{disabled:true, name:e.target.id}})
      } else {

        dispatchBuscar({type:RESET})
        dispatchBuscar({type:SET_DISABLED, payload:{disabled:true, name:e.target.id}})
      }
      setMyValues(resetValues)
      setIsfechas(false)
      
      setIsDias(false)
  
    }
  const handleLimpliar=()=>{
    setIsfechas(true)
    setSelected('')
    dispatchBuscar({type:INIT})
    dispatch(limpiarCasosBandeja())
    setMyValues(resetValues)
   querState=null
    
      setIsDias(false)
      if(rangofechas){
        setMyValues({...resetValues, fechahasta:hoy(), fechadesde:restarMeses(parseInt(rangofechas['valorParametro']))})
        }
  }
  useEffect(()=>{
    dispatchBuscar({type:INIT})

  },[])

  useEffect(()=>{   
    if (querState) {
      let resultado={}
      let valores = Object.values(querState); 
      let myKeys = Object.keys(querState); 
      for (let i=0; i< valores.length; i++) {
        if(valores[i]!=='' && myKeys[i]!=='rutcia' && myKeys[i]!=='rutusr' ){
          if (myKeys[i]==='audienciapendiente') {
            setIsDias(valores[i])
            
          } else {
            if (valores[i]!==false) {
              resultado[myKeys[i]]=valores[i]
            }
          }
        }
      }      
      let valoresR = Object.values(resultado); 
      let myKeysR = Object.keys(resultado); 
      let filter={...resetValues}
      for (let i=0; i< valoresR.length; i++) {
        
        if (Object.entries(resultado).length===1) {
              setNoFechas(false)
              dispatchBuscar({type:RESET})
              dispatchBuscar({type:SET_DISABLED, payload:{disabled:true, name:myKeysR[i]}})
              setMyValues({...resetValues,[myKeysR[i]]:valoresR[i], fechadesde:''})
        } else {
          if (myKeysR[i]==='tipogestion') {
            setNoFechas(false)
            dispatchBuscar({type:RESET})
            dispatchBuscar({type:SET_TIPO_GESTION, payload:{disabled:true, name:myKeysR[i]}})
            for (let j=0; j< Object.entries(resultado).length; j++) {
              filter[myKeysR[j]]=valoresR[j]
            }
            setMyValues(filter)
          
          } else {
            
            setNoFechas(false)
            for(let j=0; j< Object.entries(resultado).length; j++){
              if(myKeysR[j]==='tarea' || myKeysR[j]==='estadocaso'){
                dispatchBuscar({type:RESET})
              dispatchBuscar({type:SET_DISABLED, payload:{disabled:false, name:myKeysR[j]}})
              }
              filter[myKeysR[j]]=valoresR[j]
            }
            setMyValues(filter)
          }
        }      
      }
     
      querState['rutcia'] = rutOrganizacion && rutOrganizacion
      querState['rutusr'] =rutUsuario && rutUsuario
      let query1 = Buffer.from(JSON.stringify(querState)).toString('base64')
      dispatch(obtenerCasosBandeja(query1))
     
    }
 
  setIsfechas(false)
    querState = null
    history('/area-trabajo-recupero-companias')
  },[state])

  useEffect(()=>{
    if(rangofechas && querState!==null && noFechas){
    setMyValues({...myValues, fechahasta:hoy(), fechadesde:restarMeses(rangofechas && parseInt(rangofechas['valorParametro']))})
  }
  },[rangofechas])

  const onSubmitByColor = (color) => {
    setLoading(true)
    let todos = document.getElementById('todos') ? document.getElementById('todos').checked : false;
    let query = { rutcia: rutOrganizacion, rutusr: rutUsuario, todos: todos, color: color}
    
    localStorage.setItem('filtrosRecuperoCias',JSON.stringify(query));
    query = Buffer.from(JSON.stringify(query)).toString('base64');
    
    dispatch(obtenerCasosBandeja(query)).then(() => {
      setLoading(false)
    })
  }
  const obtenerTareasUsuario = () => {
    let query = Buffer.from(JSON.stringify({ rutcia: rutOrganizacion, rutusr: rutUsuario, flujo: 2, flujo1: 5 })).toString('base64')
    setLoading(true)
    dispatch(
      obtenerTareasUsuarioAction(query)
    ).then(() => {

      let queryTareas = Buffer.from(
        JSON.stringify({rutcia: rutOrganizacion, rutusr: rutUsuario, flujo: 2, flujo1: 5, 
          todos: document.getElementById('todos')
            ? document.getElementById('todos').checked
            : false
        })
      ).toString('base64')
      dispatch(obtenerTareasAction(queryTareas)).then(() => {
          setLoading(false)
      })
    })
  }

  const formik = useFormik({
    initialValues: {
      tipogestion: '',      
      todos: false,
      tarea:'',
      estadocaso:'',
      intanciajudicial:'',
      audienciapendiente: false,
      dias: '',
      fechadesde:'',
      fechahasta:'',
      tipofecha: '',
      siniestro: '',
      patente:'',
      idcaso: '',
      sitDePendiente: ''

    },
    validationSchema: validationSchemas(isFechas, isDias, selected),
    onSubmit: (formData) => {
        const dataForm = {
            ...formData
        }
        let query ={}
        dataForm['rutcia'] = rutOrganizacion && rutOrganizacion
        dataForm['rutusr'] = rutUsuario && rutUsuario  
        dataForm['tipoGestion'] = tipoGestion && tipoGestion  
        for (let key in dataForm) {
          if (dataForm[key] !== null && dataForm[key] !== '') {
            query[key] = dataForm[key]
          }  
        }                 
        setLoading(true)
        localStorage.setItem('filtrosRecuperoCias',JSON.stringify(query))
        query = Buffer.from(JSON.stringify(query)).toString('base64')
        dispatch(limpiarCasosBandeja()) 
        dispatch(obtenerCasosBandeja(query)).then(() => {
          setLoading(false)        
        })
    }
})

  return (
    <>
 <style type='text/css'>
        {`
    .btn-limpiar {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-buscar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    
    `}
    </style>
      <LoadingComponent show={loading}/>
    <Form onSubmit={
                formik.handleSubmit
            }>
          <Container>
            <Container>
           
              {cfg_form? (
                <div >
                  
                
                
                  <Row >
                  {/* RG-536: la fila pasa a cuatro columnas para alojar "Todo Responsable",
                      que antes vivía en la fila de Evaluación CIA (eliminada). */}
                  <Col md='3'>
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejarecuperocias-filtro-tarea']}
                      <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Recargar Tareas Pendientes </Tooltip>}>
                        <Button type="button" style={{ float: 'right', backgroundColor: 'white', color: 'black', border: 'none', marginBottom:'-7px' }} variant="outline-secondary" size="sm" onClick={() => obtenerTareasUsuario()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                            </svg>
                        </Button>
                      </OverlayTrigger>
                   </Form.Label>{' '}
                   <br />
                   <InputGroup>
                     <InputGroup.Radio aria-label="Radio button for following text input" 
                     name='select' id='tarea' 
                     checked={stateBuscar.tarea.disabled}
                     onChange={e=>handleRadio(e)}/>
                     <Form.Select disabled={!stateBuscar.tarea.disabled}
                      onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,tarea:e.target.value})
                       
                      }}
                      value={formik.values.tarea=myValues.tarea}
                      name='tarea'
                      error={formik.values.error}
                     >
                     <option value={''}>Seleccione...</option>
                        {tareas &&
                          tareas?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                     </Form.Select>
                 </InputGroup>
                 {formik.errors.tarea ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tarea}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                 </Col>                              
                 <Col md='3'>
                   <Form.Label className='mb-2 mt-4'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejarecuperocias-filtro-estadocaso']}
                   </Form.Label>{' '}
                   <br />
                   <InputGroup>
                     <InputGroup.Radio aria-label="Radio button for following text input" 
                     name='select' id='estadocaso' 
                     checked={stateBuscar.estadocaso.disabled}
                     onChange={e=>handleRadio(e)}/>
                     <Form.Select disabled={!stateBuscar.estadocaso.disabled}
                      onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,estadocaso:e.target.value})                       
                      }}
                      value={formik.values.estadocaso=myValues.estadocaso}
                      name='estadocaso'
                      error={formik.values.error}
                     >
                     <option value={''}>Seleccione...</option>
                        {estadocaso &&
                          estadocaso?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                     </Form.Select>
                 </InputGroup>
                 {formik.errors.estado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.estado}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                 </Col>
                 <Col md='3' >
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejarecuperocias-filtro-compania']}
                   </Form.Label>{' '}
                   <br />
                   <Form.Select disabled={!stateBuscar.companias.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,companias:e.target.value})
                      }}
                      value={formik.values.companias=myValues.companias}
                      name='companias'
                      error={formik.values.error}
                   >
                   <option value={''}>Seleccione...</option>
                        {companias &&
                          companias?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                 </Col>
                 <Col md='3'>
                    <Form.Check
                      type='checkbox'
                      id='todos'
                      name='todos'
                      checked={Boolean(myValues.todos)}
                      label={cfg_form['bandejarecuperocias-filtro-todos']}
                      style={{marginTop:'60px'}}
                      onChange={e=>{
                        formik.handleChange(e)
                        setMyValues({...myValues, todos:(e.target.checked)})
                      }}
                      value={formik.values.todos=myValues.todos}
                    />
                  </Col>
               </Row>
               {/* RG-536: se eliminan los filtros Evaluación CIA y Estado Evaluación CIA. */}
                <Row >
                 <Col md='2'>
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejarecuperocias-filtro-fechadesde']}
                   </Form.Label>{' '}
                   <br />                   
                  <Form.Control type='date'disabled={!stateBuscar.fechadesde.disabled}
                    name='fechadesde'
                    value={formik.values.fechadesde=myValues.fechadesde}
                    onChange={(e)=>{
                       formik.handleChange(e)
                       setMyValues({...myValues,fechadesde:e.target.value})                      
                      }
                    }
                  ></Form.Control>                
                 </Col>
                 <Col md='2' >
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejarecuperocias-filtro-fechahasta']}
                   </Form.Label>{' '}
                   <br />
                   <Form.Control type='date'  disabled={!stateBuscar.fechahasta.disabled}
                      name='fechahasta'
                      value={formik.values.fechahasta=myValues.fechahasta}
                      onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,fechahasta:e.target.value})                        
                      }
                      }
                   ></Form.Control>
                 </Col>
                 <Col md='3' >
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejarecuperocias-filtro-tipofecha']}
                   </Form.Label>{' '}
                   <br />
                   <Form.Select  disabled={!stateBuscar.tipofecha.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,tipofecha:e.target.value})                       
                      }}
                      value={formik.values.tipofecha=myValues.tipofecha}
                      name='tipofecha'
                      error={formik.values.error} 
                   >
                   <option value={''}>Seleccione...</option>
                        {criteriofecha &&
                         criteriofecha?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                   {formik.errors.tipofecha ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tipofecha}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                 </Col>
                 <Col md='3' > 
                   <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                     {cfg_form['bandejarecuperocias-filtro-sitpendiente']}
                   </Form.Label>{' '}
                   <br />
                   <Form.Select  disabled={!stateBuscar.sitDePendiente.disabled}
                       onChange={(e)=>{
                        formik.handleChange(e)
                        setMyValues({...myValues,sitDePendiente:e.target.value})
                       
                      }}
                      value={formik.values.sitDePendiente=myValues.sitDePendiente}
                      name='sitDePendiente'
                      error={formik.values.error} 
                   >
                   <option value={''}>Seleccione...</option>
                        {situacionPendientes &&
                         situacionPendientes?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                   </Form.Select>
                   {formik.errors.sitDePendiente ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.sitDePendiente}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                 </Col>                 
               </Row>
               <Row >
                 
                    <Col>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form[
                            'bandejarecuperocias-filtro-siniestro'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input" name='select' id='siniestro' onChange={e=>handleRadio(e)} checked={stateBuscar.siniestro.disabled}/>
                        <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.siniestro.disabled}
                          onChange={(e)=>{
                            formik.handleChange(e)                          
                           
                            setMyValues({...myValues,siniestro:e.target.value})
                          }}
                          value={formik.values.siniestro=myValues.siniestro}
                          name='siniestro'
                          error={formik.values.error}
                        />
                    </InputGroup>
                    {formik.errors.siniestro ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.siniestro}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col >
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form[
                            'bandejarecuperocias-filtro-patente'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input" name='select'
                             id='patente' checked={stateBuscar.patente.disabled}
                             onChange={e=>handleRadio(e)} />
                        <FormControl aria-label="Text input with radio button"  disabled={!stateBuscar.patente.disabled}
                            onChange={(e)=>{
                              formik.handleChange(e)
                              setMyValues({...myValues,patente:e.target.value})
                              
                            }}
                            value={formik.values.patente=myValues.patente}
                            name='patente'
                            error={formik.values.error}
                        />
                        
                          
                    </InputGroup>
                    {formik.errors.patente ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.patente}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col >
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form[
                            'bandejarecuperocias-filtro-idcaso'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <InputGroup>
                        <InputGroup.Radio aria-label="Radio button for following text input"
                         name='select' id='idcaso' 
                         checked={stateBuscar.idcaso.disabled}
                         onChange={e=>handleRadio(e)}/>
                        <FormControl aria-label="Text input with radio button" disabled={!stateBuscar.idcaso.disabled}
                          onChange={(e)=>{
                            formik.handleChange(e)
                            
                            setMyValues({...myValues, idcaso: e.target.value})
                          }}
                          value={formik.values.idcaso=myValues.idcaso}
                          name='idcaso'
                          error={formik.values.error}
                      
                        />
                    </InputGroup>
                    {formik.errors.idcaso ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.idcaso}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    
                    
                  </Row>
                  
                         
               <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
               {tareasusuario && tareasusuario[0] && tareasusuario[0].visualizaSemaforo === 1 ? (
                  <Row className='mt-4'>
                    <Col md='6'>
                      <ListGroup variant='flush'>
                        <ListGroup.Item
                          action
                          className='text-center'
                          onClick={() => {
                            obtenerTareasUsuario()
                          }}
                          type='button'
                        >
                          <Row>
                            <Col>
                              <span className='fw-bolder me-2'>
                                {cfg_form['bandejarecuperocias-semaforo-titulo']}
                              </span>
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='16'
                                height='16'
                                fill='currentColor'
                                className='bi bi-arrow-clockwise'
                                viewBox='0 0 16 16'
                              >
                                <path
                                  fillRule='evenodd'
                                  d='M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z'
                                />
                                <path d='M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z' />
                              </svg>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                    <Col md='4'>
                      <ListGroup variant='flush'>
                        <ListGroup.Item className='text-center'>
                          <Row>
                            <Col className='fw-bolder'>Casos Abiertos</Col>
                          </Row>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                    <Col md='2'></Col>
                  </Row>
                ) : (
                  <Row className='mt-4'>
                    <Col md='4'>
                      <ListGroup variant='flush'>
                        <ListGroup.Item className='text-center'>
                          <Row>
                            <Col className='fw-bolder'>Casos Abiertos</Col>
                          </Row>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                    <Col md='6'></Col>
                    <Col md='2'></Col>
                  </Row>
                )}

                {tareasusuario && tareasusuario[0] && tareasusuario[0].visualizaSemaforo === 1 ? (
                  <Row>
                    <Col md='6'>
                      <ListGroup horizontal>
                        <ListGroup.Item
                          action
                          variant='danger'
                          className='text-center'
                          onClick={() => onSubmitByColor('rojo')}
                          type='button'
                        >
                          <Row>
                            <Col md='8'>{tareasusuario[0].nivel1}</Col>
                            <Col md='4'>
                              <Badge bg='danger'>{tareasusuario[0].rojo}</Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                        <ListGroup.Item
                          action
                          variant='warning'
                          className='text-center'
                          onClick={() => onSubmitByColor('amarillo')}
                          type='button'
                        >
                          <Row>
                            <Col md='8'>{tareasusuario[0].nivel2}</Col>
                            <Col md='4'>
                              <Badge bg='warning'>
                                {tareasusuario[0].amarillo}
                              </Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                        <ListGroup.Item
                          action
                          variant='success'
                          className='text-center'
                          onClick={() => onSubmitByColor('verde')}
                          type='button'
                        >
                          <Row>
                            <Col md='9'>{tareasusuario[0].nivel3}</Col>
                            <Col md='3'>
                              <Badge bg='success'>
                                {tareasusuario[0].verde}
                              </Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                        <ListGroup.Item className='w-100 text-center'>
                          <Row>
                            <Col md='8'>Total</Col>
                            <Col md='4'>
                              <Badge>{tareasusuario[0].total}</Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                    <Col md='4'>
                      <ListGroup horizontal>
                        <ListGroup.Item className='w-100 text-center'>
                          <Row>
                            <Col md='8'>ExtraJudicial</Col>
                            <Col md='4'>
                              <Badge bg='light' text='dark'>
                                {tareasusuario[0].casosExtraJudi}
                              </Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                        <ListGroup.Item className='w-100 text-center'>
                          <Row>
                            <Col md='8'>Judicial</Col>
                            <Col md='4'>
                              <Badge bg='light' text='dark'>
                                {tareasusuario[0].casosJudi}
                              </Badge>
                            </Col>
                          </Row>
                        </ListGroup.Item>
                      </ListGroup>
                    </Col>
                  
               
                        
                        <Col className='d-flex align-items-end justify-content-end m-2'>
                        <Button className='m-2' variant='limpiar' onClick={handleLimpliar}  >
                        {cfg_form && cfg_form["bandejarecuperocias-boton-limpiar"]}
                        </Button>
                        <Button className='m-2' variant='buscar' type='onSubmit' >
                        {cfg_form && cfg_form["bandejarecuperocias-boton-buscar"]}
                        </Button>
                        
                        
                        
                        </Col>
                    </Row>):(
                      <Row>
                      <Col md='4'>
                        <ListGroup horizontal>
                          <ListGroup.Item className='w-100 text-center'>
                            <Row>
                              <Col md='8'>ExtraJudicial</Col>
                              <Col md='4'>
                                <Badge bg='light' text='dark'>
                                  {tareasusuario && tareasusuario[0] &&
                                    tareasusuario[0].casosExtraJudi}
                                </Badge>
                              </Col>
                            </Row>
                          </ListGroup.Item>
                          <ListGroup.Item className='w-100 text-center'>
                            <Row>
                              <Col md='8'>Judicial</Col>
                              <Col md='4'>
                                <Badge bg='light' text='dark'>
                                  {tareasusuario && tareasusuario[0] && tareasusuario[0].casosJudi}
                                </Badge>
                              </Col>
                            </Row>
                          </ListGroup.Item>
                        </ListGroup>
                      </Col>
                      <Col className='d-flex align-items-end justify-content-end m-2'>
                        <Button className='mx-2' variant='limpiar' onClick={handleLimpliar}  >
                        {cfg_form && cfg_form["bandejarecuperocias-boton-limpiar"]}
                        </Button>
                        <Button className='mx-2' variant='buscar' type='onSubmit' >
                        {cfg_form && cfg_form["bandejarecuperocias-boton-buscar"]}
                        </Button>
                        
                        
                        
                        </Col>
                        </Row>
                    )}
                    
                </div>
              ) : null}
            </Container>          
          </Container>       
     </Form>
    </>
  )
}

export default BuscarCasos
